import { INGREDIENT_CHECKER } from "../constants/url";
import { useAppDispatch } from "../hooks/reduxHooks";
import { catchErrors } from "../utils/catchErrors";
import { getApiCall, genericApiCall } from "../utils/servicesBaseUtil";
import { message } from "antd";

export const getIngredientCheckerApi = ({
  survey_id,
  finalCallback,
  successCallback,
  unAunthenticatedCallback,
}) => {
  return () => {
    let url = `${INGREDIENT_CHECKER}?survey_id=${survey_id}`;

    getApiCall({ url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson?.data);
        } else {
          if (unAunthenticatedCallback) {
            unAunthenticatedCallback();
          }
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        if (finalCallback) {
          finalCallback();
        }
      });
  };
};

export const saveIngredientCheckerApi = ({
  data,
  finalCallback,
  successCallback,
  failureCallback,
}) => {
  return (dispatch) => {
    let url = INGREDIENT_CHECKER;

    genericApiCall({
      url: url,
      method: "POST",
      data: JSON.stringify(data),
      ContentType: "application/json",
    })
      .then((responseJson) => {
        if (responseJson?.success) {
          message.success(responseJson?.message);
          successCallback(responseJson);
        } else {
          message.error(responseJson?.message);
          failureCallback(responseJson?.data);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};
